
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import Store from 'stores/Store'
import * as Sentry from '@sentry/react'
import './assets/css/main.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release:
    import.meta.env.VITE_RELEASE ||
    import.meta.env.VERCEL_GIT_COMMIT_SHA ||
    import.meta.env.GITHUB_SHA,
  // eslint-disable-next-line import/namespace
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true }}>
      <Provider store={Store}>
        <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>} showDialog>
          <App />
        </Sentry.ErrorBoundary>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)
